























































export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-log/index.vue"
}
